import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import MD5 from 'crypto-js/md5';
import { useDetectInputMethod } from '../hooks/useDetectInputMethod.js';
import { useTheme } from '../hooks/useTheme.js';
import { renderProp } from '../utils/renderProp.js';
import { SelectableOption } from './SelectableOption.js';
import { useSelectableContext } from './SelectableProvider.js';
import { useScrollActiveIntoView } from './useScrollActiveIntoView.js';

var SelectableOptions = function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var context = useSelectableContext();
    var isUsingKeyboard = useDetectInputMethod().isUsingKeyboard;
    useScrollActiveIntoView();
    var activeOption = context.activeOption, keyDownHandler = context.keyDownHandler, labelledby = context.labelledby, listRef = context.listRef, look = context.look, mount = context.mount, multiple = context.multiple, onFocus = context.onFocus, options = context.options, required = context.required, selectId = context.selectId, size = context.size;
    var children = props.children, sx = props.sx, ulProps = __rest(props, ["children", "sx"]);
    var css = handleStyleProps(__assign({ look: look, mount: mount, size: size, keyboard: isUsingKeyboard(), sx: sx }, ulProps), {
        themeKey: "selectableOptions",
        baseStyle: { boxSizing: "border-box" },
    }).css;
    var listItems = renderProp({ prop: children, context: context });
    if (!listItems) {
        listItems = options.map(function (option) { return (jsx(SelectableOption, { option: option }, option.value)); });
    }
    return (jsx("ul", __assign({ id: "".concat(selectId, "-list"), tabIndex: 0, ref: listRef, role: "listbox", "aria-activedescendant": activeOption ? "".concat(selectId, "-").concat(MD5(activeOption.value)) : undefined, "aria-labelledby": labelledby, "aria-multiselectable": multiple, "aria-required": required, css: css, onKeyDown: keyDownHandler, onFocus: onFocus }, ulProps, { children: listItems })));
};
SelectableOptions.displayName = "SelectableOptions";

export { SelectableOptions };
//# sourceMappingURL=SelectableOptions.js.map
